export default {
  root: ({ context }) => ({
    class: [
      'flex items-center justify-between outline-transparent',
      'text-2xl font-medium w-ful',
      {
        'focus-visible:outline-offset-2 focus-visible:ring-1 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400': !context.disabled
      },
      {
        'hover:text-surface-700 dark:hover:text-surface-0': !context.disabled
      }
    ]
  }),
  toggleIcon: 'inline-block text-surface-900 dark:text-surface-0 w-4 h-4'
}
